import { render, staticRenderFns } from "./BulkAdjustPriceModal.vue?vue&type=template&id=484e79d8&scoped=true"
import script from "./BulkAdjustPriceModal.vue?vue&type=script&lang=js"
export * from "./BulkAdjustPriceModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "484e79d8",
  null
  
)

export default component.exports